<template>
  <div class="addcorpusDialog">
    <el-dialog :close-on-click-modal="false" :show-close="false" :visible.sync="addcorpusVisible"
               :before-close="handlerClose" custom-class="add-corpus-dialog">
      <template slot="title">
        <DialogsHeader
                       :title="bankType === 'memory'?$t('memoryBankV2.createMemoryBank'):$t('termBankV2.createTermBank')" />
      </template>
      <div class="content">
        <el-form :model="ruleForm" ref="ruleForm" :rules="rules">
          <!-- 库名 -->
          <el-form-item :label="$t('memory.libName')+':'" prop="name">
            <el-input v-model.trim="ruleForm.name"
                      :placeholder="$t('termBankV2.pleaseInputActivity')"></el-input>
          </el-form-item>
          <!-- 语言对 -->
          <el-row>
            <el-col :span="11">
              <el-form-item prop="sourceLang" :label="$t('memory.sourceLang')+':'">
                <el-select clearable @clear="clearSource" @change="changeSource"
                           v-model="ruleForm.sourceLang"
                           :placeholder="$t('memoryBankV2.pleaseLanguage')">
                  <el-row v-for="(item,index) in sourceLangList" :key="index">
                    <el-col v-if="index % 2 == 1" :span="12">
                      <el-option :label="$i18n.locale==='zh'?sourceLangList[index-1].sourceLangName: $langCase[sourceLangList[index-1].sourceLang]"
                                 :value="sourceLangList[index-1].sourceLang">
                      </el-option>
                    </el-col>
                    <el-col v-if="index % 2 == 1 || (index % 2 == 0 && index == sourceLangList.length-1)"
                            :span="12">
                      <el-option :label="$i18n.locale==='zh'?item.sourceLangName: $langCase[item.sourceLang]"
                                 :value="item.sourceLang"></el-option>
                    </el-col>
                  </el-row>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="2">
              <div class="img-box">
                <img src="@/assets/imgs/memory/transfer.png" alt="">
              </div>
            </el-col>
            <el-col :span="11">
              <el-form-item prop="targetLang" :label="$t('memory.targetLang')+':'">
                <el-select clearable :no-data-text="$t('termBankV2.pleaseLanguage')"
                           @clear="clearTarget" @change="changeTarget" v-model="ruleForm.targetLang"
                           :placeholder="$t('memoryBankV2.pleaseTargetLanguage')">
                  <el-row v-for="(item,index) in targetLangList" :key="index">
                    <el-col v-if="index % 2 == 1" :span="targetLangList.length>2?12:24">
                      <el-option :label="$i18n.locale==='zh'?targetLangList[index-1].targetLangName:$langCase[targetLangList[index-1].targetLang]"
                                 :value="targetLangList[index-1].targetLang"></el-option>
                    </el-col>
                    <el-col v-if="targetLangList.length>1 && index % 2 == 1 || (index % 2 == 0 && index == targetLangList.length-1)"
                            :span="targetLangList.length>2?12:24">
                      <el-option :label="$i18n.locale==='zh'?item.targetLangName:$langCase[item.targetLang]"
                                 :value="item.targetLang"></el-option>
                    </el-col>
                  </el-row>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <!-- 领域 -->
          <el-form-item :label="$t('statistics.theField')" prop="domainCode">
            <!-- :filterable="CUSTOM_DOMAIN" :allow-create="CUSTOM_DOMAIN"
                       :default-first-option="CUSTOM_DOMAIN" -->
            <el-select ref="domainSelect" v-model="ruleForm.domainCode"
                       popper-class="add-domain-select-dropdown"
                       :placeholder="$t('memoryBankV2.pleaseDomain')" clearable @clear="cleardomain"
                       @change="changedomainCode">
              <el-option value="add_domain" v-if="CUSTOM_DOMAIN"><span>+创建</span></el-option>
              <el-option v-for="(item,index) in domainCodeOption" :key="index"
                         :label="$i18n.locale==='zh'?item.dataDesc:$domainCase[item.dataKey]"
                         :value="item.dataKey">
              </el-option>
            </el-select>
          </el-form-item>

          <!-- 上传 -->
          <el-form-item class="upload">
            <div class="lable">
              {{$t("memory.corpusfile")}} <i class="lable-num">{{fileList.length}}</i> <em>
                ({{bankType==='memory'?$t("memory.Itsupportstmxxlsxtxtzipfilesandthesizeofasinglefiledoesnotexceed20M"):$t("memory.Itsupportstbxxlsxtxtzipfilesandthesizeofasinglefiledoesnotexceed20M")}})</em>
            </div>
            <div class="file-list">
              <div v-for="(item,index) in fileList" :key="index" class="uploads">
                <span class="file-delete" @click="handleDelete"></span>
                <div class="file-img"></div>
                <div class="file-name">{{item.name}}</div>
              </div>
              <el-upload class="upload-demo" drag action :limit="20" :on-exceed="handleExceed"
                         :on-progress="uploadFileProcess" :show-file-list="false"
                         :accept="bankType==='memory'?'.xlsx, .txt, .tmx,.zip,':'.xlsx, .txt, .tbx,.zip,'"
                         :http-request="uploadSectionFile" :before-upload="beforeUploadFile"
                         :file-list="fileList" :on-change="uploadChange" multiple>
                <div class="upload-img">
                </div>
                <div class="text">上传文件</div>
              </el-upload>
            </div>
          </el-form-item>
          <!-- 备注 -->
          <el-form-item :label="$t('termBankV2.remark')" prop="remark">
            <el-input :rows="3" type="textarea" resize="none" v-model="ruleForm.remark"
                      :placeholder="$t('termBankV2.pleaseInputRemark')">
            </el-input>
          </el-form-item>
        </el-form>
        <!-- 模板下载 -->
        <!-- :style="{paddingLeft:$i18n.locale === 'zh' ?'82px':'140px'}" -->
        <!-- <div class="downloadTemplate">
          <span class="required">*</span>
          <span>{{$t('termBankV2.clickIconDownloadTemp')}}</span>
          <a v-for="item in exportTemplateData" :key="item.type"
             :href="downloadTemplate(item.type)">
            <img :src="item.imgUrl">
          </a>
        </div>-->
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handlerClose" size="small">{{$t('termBankV2.cancel')}}</el-button>
        <el-button v-preventReClick type="primary" size="small" @click="handlerdetermine">
          {{$t('termBankV2.confirm')}}
        </el-button>
      </span>
    </el-dialog>
    <!-- 创建自定义领域 -->
    <create-custom-domain :dialogVisible="createDomainVisible"
                          @handleClose="handleCreateDomainClose"
                          @handleConfirm="handleCreateDomainConfirm">
    </create-custom-domain>
  </div>
</template>
<script>
import { getOptionList } from "@/services/memoryBank";
// 标题组件
import DialogsHeader from '@/common/dialogsHeader';
import CreateCustomDomain from '@/components/create-custom-domain';
import axios from "axios";
import { getLang, addTerm } from "@/services/term";
import { addMemory } from "@/services/memoryBank";
import { getUploadSign } from "@/services/newProjectApi";
import { deepClone } from '@/utils';

export default {
  name: "addcorpusDialog",
  data () {
    // const checkDomain = (rule, value, callback) => {
    //   if (value === '') {
    //     return callback(new Error(this.$t('termBankV2.pleaseDomain')))
    //   }
    //   if (this.$refs.domainSelect.createdSelected && this.CUSTOM_DOMAIN) {
    //     this.ruleForm.domainCode = this.ruleForm.domainCode.trim();
    //     if (value.length < 1 || value.length > 10) {
    //       return callback(new Error(this.$t('common.customDomainLength')));
    //     }
    //   }
    //   callback();
    // }
    return {
      CUSTOM_DOMAIN: CUSTOM_DOMAIN,
      fileList: [],
      rules: {
        name: [
          { required: true, message: this.$t('termBankV2.pleaseInputActivity'), trigger: "blur" },
          { min: 1, max: 50, message: this.$t('termBankV2.WithinSixteenLength'), trigger: "blur" }
        ],
        sourceLang: [
          { required: true, message: this.$t('termBankV2.pleaseLanguage'), trigger: "change" }
        ],
        targetLang: [
          { required: true, message: this.$t('termBankV2.pleaseTargetLanguage'), trigger: "change" }
        ],
        domainCode: [
          { required: true, message: this.$t('termBankV2.pleaseDomain'), trigger: "change" }
          // { required: true, validator: checkDomain, trigger: 'change' }
        ],
        remark: [
          { min: 0, max: 140, message: this.$t('termBankV2.WithinFiftyLength', [140]), trigger: "blur" }
        ]
      },
      //表单数据源
      ruleForm: {
        domainCode: "",
        domainName: "",
        langDesc: "",
        name: "",
        sentFileUrlList: [],
        sourceLang: "",
        sourceLeft: "",
        sourceRight: "",
        targetLang: "",
        remark: ""
      },
      domainCodeCopy: "", //dimaincode拷贝的值
      domainCodeOption: [],//领域列表
      sourceLangList: [],
      targetLangList: [],
      createDomainVisible: false
    }
  },
  components: { DialogsHeader, CreateCustomDomain },
  props: {
    addcorpusVisible: {
      type: Boolean,
      required: true
    },
    bankType: {
      type: String,
      required: true
    },
    langList: { //源语言
      type: Array,
      default: () => []
    },
    // optionList: { //领域
    //   type: Array,
    //   default: () => []
    // },
  },
  watch: {
    addcorpusVisible: {
      handler (value) {
        if (value) {
          this.getDomainList()
        }
      }
    },
    langList: {
      handler (value) {
        this.sourceLangList = value
      }
    },
    // optionList: {
    //   handler (value) {
    //     this.domainCodeOption = value;
    //   }
    // }
  },
  methods: {
    cleardomain () {
      this.domainCodeCopy = ""
    },

    async getDomainList () {
      const { success, result } = await getOptionList({ dataType: "trans_domain" })
      if (success) {
        this.domainCodeOption = result;
      }
    },

    handleCreateDomainClose () {
      this.createDomainVisible = false
      this.ruleForm.domainCode = this.ruleForm.domainCode === 'add_domain' ? '' : this.ruleForm.domainCode
    },

    async handleCreateDomainConfirm (data) {
      await this.getDomainList()
      // if (!this.ruleForm.domainCode) {
        this.domainCodeOption.forEach(item => {
          if (item.dataDesc === data.domain) {
            this.ruleForm.domainCode = item.dataKey
          }
        })
      // }
      this.createDomainVisible = false
    },
    //领域change事件
    changedomainCode (value) {
      if (value === 'add_domain') {
        this.createDomainVisible = true
        this.ruleForm.domainCode = this.domainCodeCopy
        return
      }
      this.domainCodeCopy = value;
    },
    //关闭操作
    handlerClose () {
      this.cleardomain()
      this.fileList = [];
      this.ruleForm.sentFileUrlList.length = 0;
      this.$refs['ruleForm'].resetFields();
      this.$emit("handlerClose")
    },
    //删除文件
    handleDelete (index, rows) {
      this.fileList.splice(index, 1);
      this.ruleForm.sentFileUrlList.splice(index, 1);
    },
    //确定操作
    handlerdetermine () {
      this.$refs.ruleForm.validate(async (valid) => {
        if (valid) {
          const successFileList = this.fileList.filter(item => item.percentage !== -1)
          if (this.ruleForm.sentFileUrlList.length !== successFileList.length) {
            this.$message.closeAll()
            this.$message({
              message: this.$t('termBankV2.fileProcessing'),
              type: "warning"
            });
            return
          }

          const params = deepClone(this.ruleForm)
          params.domainName = this.domainCodeOption.find(item => item.dataKey === params.domainCode).dataValue
          // if (this.$refs.domainSelect.createdSelected) {
          //   params.domainName = params.domainCode
          //   params.domainCode = ''
          // } else {
          //   params.domainName = this.domainCodeOption.find(item => item.dataKey === params.domainCode).dataValue
          // }
          if (this.bankType === 'memory') {
            const { success } = await addMemory(params)
            if (success) {
              this.$message.closeAll()
              this.$message.success(this.$t("jobManagementV2.creatingSuccessful"))
              this.fileList = [];
              this.targetLangList.length = 0;
              this.ruleForm.sentFileUrlList.length = 0
              this.$emit("handlerdetermine")
              this.$refs['ruleForm'].resetFields();
            }
          } else {
            const { success } = await addTerm(params)
            if (success) {
              this.$message.closeAll()
              this.$message.success(this.$t("jobManagementV2.creatingSuccessful"))
              this.fileList = [];
              this.ruleForm.sentFileUrlList.length = 0
              this.targetLangList.length = 0;
              this.$emit("handlerdetermine")
              this.$refs['ruleForm'].resetFields();
            }
          }

        }
      })
    },
    //清除源语言
    clearSource () {
      this.ruleForm.sourceLang = "";
      this.ruleForm.targetLang = "";
      this.$nextTick(() => {
        this.$refs['ruleForm'].clearValidate(["sourceLang"]);
        this.$refs['ruleForm'].clearValidate(["targetLang"]);
      })
    },
    //选择源语言
    async changeSource (value) {
      this.ruleForm.targetLang = "";
      this.$nextTick(() => {
        this.$refs['ruleForm'].clearValidate(["targetLang"]);
      })
      this.ruleForm.sourceLeft = this.sourceLangList.find(item => item.sourceLang === value).sourceLangName;
      const { result, success } = await getLang({ type: 2, sourceLang: value });
      if (success) {
        this.targetLangList = result.filter(item => item.status !== 0);
      }
    },
    clearTarget () {
      this.$refs['ruleForm'].clearValidate(["targetLang"]);
    },
    changeTarget (value) {
      this.ruleForm.sourceRight = this.targetLangList.find(item => item.targetLang === value).targetLangName;
      this.ruleForm.langDesc = `${this.ruleForm.sourceLeft}>${this.ruleForm.sourceRight}`
    },
    // 自定义文件上传开始
    uploadSectionFile (param) {
      let self = this;
      // 获得上传签名
      getUploadSign()
        .then(({ result }) => {
          // 上传地址
          this.host = result.host;
          let re = /([^\.\/\\]+)\.([a-z]+)$/i;
          let resultArr = re.exec(param.file.name);
          // 文件类型
          let type = resultArr[2].toLocaleLowerCase();
          let para = {
            ...result,
            key: `${result.keyPrefix}.${type}`,
            file: param.file,
          };
          Reflect.deleteProperty(para, 'keyPrefix');
          Reflect.deleteProperty(para, 'host');
          self.formData = new FormData();
          Object.keys(para).forEach(function (key) {
            self.formData.append(key, para[key]);
          });
          this.getFileHost(param);
        })
        .catch(() => {
          this.fileList.forEach(item => {
            // 上传文件夹的param和单个上传的param不一样
            if (item.uid === param.file.uid) {
              item.isLoading = 0;
            }
          });
          this.$message.closeAll()
          this.$message({
            message: this.$t("termBankV2.uploadFileError"),
            type: "warning"
          });
        });
    },
    getFileHost (param) {
      let self = this;
      let FileController = self.host;
      let config = {
        onUploadProgress: progressEvent => {
          const complete =
            ((progressEvent.loaded / progressEvent.total) * 100) | 0;
          param.onProgress({ percent: complete });
        }
      };
      axios
        .post(FileController, self.formData, config)
        .then(resp => {
          let { result } = resp.data;
          self.getFileContent(result.fileName, param);
          setTimeout(() => {
            this.areaHidden = false;
          }, 500);
          this.fileList.forEach(item => {
            // 上传文件夹的param和单个上传的param不一样
            if (item.uid === param.file.uid) {
              item.path = result.fileName;
              item.isLoading = 1;
            }
          });
        })
        .catch(() => {
          this.fileList.forEach(item => {
            // 上传文件夹的param和单个上传的param不一样
            if (item.uid === param.file.uid) {
              item.isLoading = 0;
            }
          });
        });
    },
    // 检测文件编码
    getFileContent (path, param) {
      if (this.bankType === 'memory') {
        this.fileUrl = "/api/v1/memory/checkFileContent"
      } else {
        this.fileUrl = "/api/v1/term/checkFileContent"
      }
      var that = this;
      this.catReq1Service(this.fileUrl, {
        fileUrlList: [path]
      }).then(function (response) {
        if (!response.success) {
          return;
        }
        var data = response.result;

        if (data.status === 0) {
          that.$message.closeAll();
          that.$message({
            message: data.reason,
            type: "error"
          });
        }
        that.fileList.forEach(item => {
          if (item.uid === param.file.uid) {
            if (data.status === 0) {
              item.percentage = -1;
            } else {
              that.ruleForm.sentFileUrlList.push(path);
            }
          }
        });
      });
    },
    // 文件个数超出限制时触发
    handleExceed () {
      this.$message({
        message: this.$t("common.uploadMaxNum"),
        type: "warning"
      })
    },
    //上传前的函数(用于验证上传文件格式及大小)
    beforeUploadFile (file) {
      var that = this;
      let type = this.typeReg(file.name); // 拿到文件后缀
      const isTXT = type === "txt";
      const isXLSX = type === "xlsx";
      const isTBX = type === "tbx";
      const isZip = type === "zip";
      const isTMX = type === "tmx";
      let flagType = null
      if (this.bankType === 'memory') {
        flagType = isTXT || isXLSX || isTMX || isZip
        //后缀不对阻止
        if (!flagType) {
          this.$message.closeAll()
          this.$message({
            message: that.$t("memoryBankV2.supportedFormatsText"),
            type: "warning"
          })
          return false
        }
      } else {
        flagType = isTXT || isXLSX || isTBX || isZip
        if (!flagType) {
          this.$message.closeAll()
          this.$message({
            message: that.$t("termBankV2.supportedFormatsText"),
            type: "warning"
          })
          return false
        }
      }
      file.obp = true;
      this.fileList.slice(0, -1).forEach(item => {
        if (item.name === file.name) {
          this.fileList.pop();
          this.$message.closeAll();
          this.$message({
            // message: "上传文件名称重复!",
            message: that.$t("termBankV2.uploadFileRepeat") + "!",
            type: "warning"
          });
          file.obp = false;
          return false;
        }
      });
      const isLt20M = file.size / 1024 / 1024 < 20;
      if (file.size < 1) {
        this.$message.closeAll();
        this.$message({
          // message: "不支持上传空文件",
          message: that.$t("termBankV2.uploadFileContentEmpty"),
          type: "warning"
        });
        return false;
      }
      // if (this.fileList.length >= 20) {
      //   this.$message.closeAll();
      //   this.$message({
      //     // message: "上传文件名称重复!",
      //     message: "文件数量不能超过20个!",
      //     type: "warning"
      //   });
      // }
      if (!isLt20M) {
        this.$message.closeAll();
        that.$message({
          // message: "上传文件大小不能超过 50MB!",
          message: that.$t("termBankV2.uploadFileSize", [20]),
          type: "warning"
        });
        file.obp = false;
        return false;
      }
      return flagType && isLt20M;
    },

    uploadChange (event, file, fileList) {
      this.fileList = file;
    },
    //文件上传过程中的函数(在这里获取进度条的进度)
    uploadFileProcess (event, file, fileList) {
      fileList.forEach(item => {
        if (parseInt(item.percentage) === 100) {
        } else {
          item.progressPercent = Math.abs(item.percentage.toFixed(0));
        }
      });
    },
    // 删除文件
    handleDelete (index, rows) {
      var that = this;
      that.fileList.splice(index, 1);
      that.ruleForm.sentFileUrlList.splice(index, 1);
    },
    isSrc (row) {
      if (row.percentage === 100) {
        return this.succeedImgSrc;
      } else if (row.percentage === -1) {
        return this.imgSrc;
      } else {
        return require("@/assets/imgs/memory/upload_Loading.gif");
      }
    }
  }
}
</script>
<style lang="less" scoped>
.addcorpusDialog {
  @media (max-width: 1280px) {
    /deep/.add-corpus-dialog {
      height: 500px !important;
    }
  }
  /deep/.add-corpus-dialog {
    width: 562px;
    height: 681px;
    border-radius: 4px 4px 4px 4px;
    box-shadow: 0px 10px 28px 1px rgba(51, 51, 51, 0.18);
    .el-dialog__header {
      padding: 16px 28px 0px 32px;
    }
    .el-dialog__body {
      padding: 15px 32px 10px 32px;
      height: calc(100% - 64px - 104px);
      overflow-y: auto;
      .el-form-item {
        margin-bottom: 12px;
        .el-form-item__content {
          line-height: 0px;
        }
        .el-select {
          width: 100%;
        }
      }
      .upload {
        .lable {
          margin: 10px 0px 30px 0px;
          font-size: 14px;
          font-weight: 400;
          color: #333742;
          text-align: left;
          line-height: 20px;
          .lable-num {
            display: inline-block;
            width: 20px;
            height: 20px;
            background: #ecf3fe;
            border-radius: 2px 2px 2px 2px;
            font-size: 12px;
            font-weight: 400;
            color: #65a9e4;
            text-align: center;
          }
          em {
            font-size: 12px;
            font-weight: 400;
            color: #909399;
          }
        }
        .file-list {
          width: 100%;
          height: 100%;
          overflow-x: auto;
          display: flex;
          padding-bottom: 10px;
          .upload-demo {
            width: 104px;
            height: 104px;
            .el-upload {
              width: 104px;
              height: 100%;
              .el-upload-dragger {
                width: 100%;
                height: 100%;
                background: #f5f7fa;
                padding: 24px 0px;
                .upload-img {
                  width: 24px;
                  height: 24px;
                  background: url("../images/upload_big.png") no-repeat;
                  margin: 0 auto;
                }
                .text {
                  font-size: 14px;
                  font-weight: 400;
                  color: #606266;
                  margin-top: 12px;
                }
              }
            }
          }
          .uploads {
            width: 104px;
            height: 104px;
            background: rgba(0, 120, 252, 0.05);
            border-radius: 4px 4px 4px 4px;
            border: 1px solid rgba(0, 120, 252, 0.5);
            margin-right: 10px;
            position: relative;
            .file-delete {
              display: inline-block;
              width: 12px;
              height: 12px;
              position: absolute;
              right: 4px;
              top: 4px;
              background: url("../images/close.png");
              cursor: pointer;
            }
            .file-img {
              width: 48px;
              height: 48px;
              background: url("../images/file.png") no-repeat;
              margin: 16px 28px 5px 28px;
            }
            .file-name {
              width: 80px;
              height: 21px;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
              font-size: 14px;
              font-weight: 400;
              color: #303133;
              line-height: 21px;
              margin: 0 auto;
            }
          }
        }
      }
      .el-row {
        .el-col {
          .img-box {
            margin-top: 40px;
          }
        }
      }
    }
    .el-dialog__footer {
      display: flex;
      justify-content: center;
      .el-button {
        width: 60px;
      }
    }
  }
}
</style>